export default "__VITE_ASSET__xU4ihlgT__"